export const Gift = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="130"
      height="119"
      viewBox="0 0 130 119"
      fill="none"
    >
      <g clipPath="url(#clip0_1331_58797)">
        <path
          d="M121.882 107.327H1.04773V118.304H121.882V107.327Z"
          fill="#BBA7FF"
        />
        <path
          opacity="0.2"
          d="M121.882 114.58H1.04773V118.304H121.882V114.58Z"
          fill="#110733"
        />
        <path
          d="M106.267 54.4178L21.3982 50.0442L18.8178 100.117L103.687 104.491L106.267 54.4178Z"
          fill="#BBA7FF"
        />
        <path
          opacity="0.7"
          d="M56.8159 51.8836L42.2679 51.1339L39.6875 101.207L54.2355 101.957L56.8159 51.8836Z"
          fill="white"
        />
        <path
          opacity="0.2"
          d="M106.254 54.4255L77.6808 52.953L75.1004 103.026L103.674 104.499L106.254 54.4255Z"
          fill="#110733"
        />
        <path
          opacity="0.2"
          d="M21.3106 51.8343L77.6064 54.7354L77.6985 52.9488L21.4027 50.0477L21.3106 51.8343Z"
          fill="#110733"
        />
        <path
          d="M110.158 45.603L20.9154 36.7583L20.1616 44.3637L109.404 53.2083L110.158 45.603Z"
          fill="#BBA7FF"
        />
        <path
          opacity="0.7"
          d="M56.2091 40.2602L41.7129 38.8235L40.9591 46.4288L55.4554 47.8655L56.2091 40.2602Z"
          fill="white"
        />
        <path
          opacity="0.2"
          d="M110.155 45.5995L76.5238 42.2664L75.77 49.8718L109.401 53.2049L110.155 45.5995Z"
          fill="#110733"
        />
        <path
          d="M80.6137 34.5877C81.0518 30.17 77.8268 26.227 73.397 25.7889L85.0922 26.945C89.5098 27.3831 92.747 31.3261 92.3089 35.7438C91.8708 40.1614 87.9277 43.3986 83.5101 42.9605L75.5024 42.1694L71.8027 41.8043C76.2204 42.2425 80.1634 39.0175 80.6015 34.5877H80.6137Z"
          fill="#BBA7FF"
        />
        <path
          opacity="0.5"
          d="M80.6137 34.5877C81.0518 30.17 77.8268 26.227 73.397 25.7889L85.0922 26.945C89.5098 27.3831 92.747 31.3261 92.3089 35.7438C91.8708 40.1614 87.9277 43.3986 83.5101 42.9605L75.5024 42.1694L71.8027 41.8043C76.2204 42.2425 80.1634 39.0175 80.6015 34.5877H80.6137Z"
          fill="white"
        />
        <path
          d="M73.3972 25.7888L85.0924 26.945C80.6747 26.5068 76.7317 29.7318 76.2936 34.1617L75.5026 42.1694L63.8074 41.0133L64.5984 33.0055C65.0365 28.5879 68.9795 25.3507 73.3972 25.7888Z"
          fill="#BBA7FF"
        />
        <path
          opacity="0.7"
          d="M73.3972 25.7888L85.0924 26.945C80.6747 26.5068 76.7317 29.7318 76.2936 34.1617L75.5026 42.1694L63.8074 41.0133L64.5984 33.0055C65.0365 28.5879 68.9795 25.3507 73.3972 25.7888Z"
          fill="white"
        />
        <path
          d="M60.704 24.5353L49.0088 23.3792C53.4264 23.8173 56.6636 27.7603 56.2255 32.178L55.4344 40.1857L67.1296 41.3418L67.9207 33.3341C68.3588 28.9164 65.1338 24.9734 60.704 24.5353Z"
          fill="#BBA7FF"
        />
        <path
          opacity="0.5"
          d="M60.704 24.5353L49.0088 23.3792C53.4264 23.8173 56.6636 27.7603 56.2255 32.178L55.4344 40.1857L67.1296 41.3418L67.9207 33.3341C68.3588 28.9164 65.1338 24.9734 60.704 24.5353Z"
          fill="white"
        />
        <path
          d="M51.9053 31.7398C52.3434 27.3222 56.2864 24.085 60.7041 24.5232L49.0089 23.367C44.5913 22.9289 40.6482 26.1539 40.2101 30.5837C39.772 35.0135 42.997 38.9444 47.4268 39.3825L55.4346 40.1735L59.1342 40.5386C54.7165 40.1005 51.4794 36.1575 51.9175 31.7398H51.9053Z"
          fill="#BBA7FF"
        />
        <path
          opacity="0.7"
          d="M51.9053 31.7398C52.3434 27.3222 56.2864 24.085 60.7041 24.5232L49.0089 23.367C44.5913 22.9289 40.6482 26.1539 40.2101 30.5837C39.772 35.0135 42.997 38.9444 47.4268 39.3825L55.4346 40.1735L59.1342 40.5386C54.7165 40.1005 51.4794 36.1575 51.9175 31.7398H51.9053Z"
          fill="white"
        />
        <path
          d="M92.7476 15.8096C91.1777 15.2619 89.6078 14.7143 88.0257 14.1666C86.468 9.52995 93.4048 7.87486 91.847 3.23816C93.4169 3.7858 94.9868 4.33344 96.5689 4.88108C98.1267 9.51778 91.1899 11.1729 92.7476 15.8096Z"
          fill="#BBA7FF"
        />
        <path
          d="M14.9089 28.7096C13.8623 29.6953 12.8157 30.6933 11.7691 31.679C7.59489 31.034 9.06743 25.0465 4.89319 24.4015C5.93979 23.4157 6.9864 22.4178 8.033 21.432C12.2072 22.077 10.7347 28.0646 14.9089 28.7096Z"
          fill="#BBA7FF"
        />
        <path
          opacity="0.7"
          d="M14.9089 28.7096C13.8623 29.6953 12.8157 30.6933 11.7691 31.679C7.59489 31.034 9.06743 25.0465 4.89319 24.4015C5.93979 23.4157 6.9864 22.4178 8.033 21.432C12.2072 22.077 10.7347 28.0646 14.9089 28.7096Z"
          fill="white"
        />
        <path
          d="M121.772 45.1996C120.908 44.0435 120.044 42.8874 119.18 41.7434C120.299 37.6665 126.08 39.8206 127.2 35.7437C128.064 36.8998 128.928 38.0559 129.792 39.1999C128.672 43.2768 122.891 41.1227 121.772 45.1996Z"
          fill="#BBA7FF"
        />
        <path
          opacity="0.5"
          d="M121.772 45.1996C120.908 44.0435 120.044 42.8874 119.18 41.7434C120.299 37.6665 126.08 39.8206 127.2 35.7437C128.064 36.8998 128.928 38.0559 129.792 39.1999C128.672 43.2768 122.891 41.1227 121.772 45.1996Z"
          fill="white"
        />
        <path
          d="M45.7839 7.29069C44.8103 7.52192 43.8367 7.76532 42.8509 7.99654C40.5508 6.1589 43.5203 3.04343 41.208 1.20579C42.1816 0.974562 43.1552 0.731165 44.1409 0.499939C46.441 2.33758 43.4838 5.45305 45.7839 7.29069Z"
          fill="#BBA7FF"
        />
        <path
          d="M7.14472 66.4725C7.44896 67.4339 7.76538 68.3832 8.06962 69.3446C6.41453 71.7786 3.08 69.0525 1.42491 71.4987C1.12066 70.5373 0.804245 69.588 0.5 68.6266C2.15509 66.1926 5.48962 68.9187 7.14472 66.4725Z"
          fill="#BBA7FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1331_58797">
          <rect
            width="129"
            height="118.047"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
